import React from "react";
import { Box, Stack, Typography, Button, Dialog, DialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import Section from "src/components/Section";
import { Tag } from "src/components/Tag";
import { useResultPage } from "../hooks";
import ResultHeader from "src/components/ResultHeader";
import featureImage from "url:src/assets/images/features_result_residence.png";
import differenceImage from "url:src/assets/images/difference.png";
import CaseSection from "src/components/CaseSection";
import FAQSection from "src/components/FAQSection";
import theme from "src/styles/theme";

export default function ResultForResidencePage() {
  const { minPrice, maxPrice, submitPreciseAssessment, modalOpen, closeModal } = useResultPage();

  const PreciseAssessmentButton = styled(Button)(() => ({
    display: "flex",
    width: "289px",
    height: "56px",
    padding: "16px 10px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "4px",
    background: "linear-gradient(321deg, #FF6232 31.17%, #FF9347 79.27%)",
    boxShadow: "4px 4px 10px 0px rgba(66, 71, 80, 0.25)",
    color: "white",
    textTransform: "none",
    fontWeight: "bold",
    "&:hover": {
      opacity: 0.9,
      background: "linear-gradient(321deg, #FF6232 31.17%, #FF9347 79.27%)",
    },
  }));

  return (
    <>
      <ResultHeader backgroundType="residence_result">
        <Box
          sx={{
            width: "333px",
            height: "73px",
            bgcolor: "white",
            justifyContent: "center",
            borderRadius: "4px",
            boxShadow: "0px 4px 10px 0px rgba(66, 71, 80, 0.25)",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="flex-end" gap={1} py={2}>
            <Typography
              fontSize="40px"
              fontWeight="bold"
              sx={{
                background: "linear-gradient(337deg, #FF6232 -9.47%, #FF9347 125.83%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                display: "inline-block",
                lineHeight: 1,
              }}
            >
              {minPrice}〜{maxPrice}
            </Typography>
            <Typography color={theme.palette.text.primary} fontWeight="bold" fontSize="20px" component="span">
              万円
            </Typography>
          </Box>
        </Box>
      </ResultHeader>

      {/* 精密査定説明セクション */}
      <Section sx={{ p: 0 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src={featureImage} alt="Agent Icon" style={{ display: "block", margin: "0 auto", width: "100%" }} />
          <Box pt={2} pb={5}>
            <PreciseAssessmentButton onClick={submitPreciseAssessment}>
              <Tag label="無料" color="primary" sx={{ mr: 1, color: "#FF9146" }} />
              精密査定を依頼する
            </PreciseAssessmentButton>
          </Box>
        </Box>
      </Section>

      {/* AI簡易査定と精密査定の違いセクション */}
      <Section sx={{ p: 0 }} colored>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src={differenceImage} alt="Agent Icon" style={{ display: "block", margin: "0 auto", width: "100%" }} />
          <Box pt={3} pb={5}>
            <PreciseAssessmentButton onClick={submitPreciseAssessment}>
              <Tag label="無料" color="primary" sx={{ mr: 1, color: "#FF9146" }} />
              精密査定を依頼する
            </PreciseAssessmentButton>
          </Box>
        </Box>
      </Section>

      {/* 成約事例セクション */}
      <Section title="成約事例">
        <CaseSection />
      </Section>

      {/* よくある質問セクション */}
      <Section title="よくある質問" colored>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <FAQSection colored />
          <Box pt={3}>
            <PreciseAssessmentButton onClick={submitPreciseAssessment}>
              <Tag label="無料" color="primary" sx={{ mr: 1, color: "#FF9146" }} />
              精密査定を依頼する
            </PreciseAssessmentButton>
          </Box>
        </Box>
      </Section>

      <Dialog open={modalOpen} onClose={closeModal} maxWidth="sm" fullWidth>
        <DialogContent>
          <Stack spacing={2}>
            <Typography color="primary.dark" variant="h6" fontWeight="bold" textAlign="center">
              精密査定を依頼しました
            </Typography>
            <Typography variant="body2">
              ご依頼から3営業日前後で担当よりご連絡いたします。
              <br />
              その他お客様の検討状況・ご要望にあわせてご案内いたします。何でもご相談ください。
              <br />
              ※定休日は土日祝となります。ご依頼が定休日の場合は、回答にお時間をいただく場合がございます。ご了承ください。
            </Typography>
            <Button variant="contained" color="primary" fullWidth onClick={closeModal}>
              とじる
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
